import { useState } from "react";
import DrawerClosetRTPValidationComplete from "./DrawerClosetRTPValidationComplete";
import DrawerClosetRTPNextStepsExplanation from "../../DrawerClosetRTPNextStepsExplanation";

function DrawerClosetRTP() {
  const [step, setStep] = useState("closetValidationComplete");

  return (
    <>
      <DrawerClosetRTPValidationComplete setStep={setStep} />
      <DrawerClosetRTPNextStepsExplanation
        open={step === "nextStepsExplanation"}
        setStep={setStep}
      />
    </>
  );
}

export default DrawerClosetRTP;
